import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { DisplayDate, OwaDate, owaDate } from 'owa-datetime';

/**
 * Converts a Date into an Owa Date in the given time zone
 * @param date Creates a Owa Date from a date and a time zone
 * @param timeZone The time zone that should be assumed for the date
 */
export default function displayDateToOwaDate(date: DisplayDate, timeZone?: string): OwaDate {
    if (!timeZone) {
        // TZ_BUG: This function must go away; in the meantime,
        // don't crash and use UTC in test cases that do not mock user config.
        const { UserOptions } = getUserConfiguration();
        timeZone = UserOptions && UserOptions.TimeZone;
    }

    return owaDate(
        timeZone,
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
    );
}
